export const breakpoints = {
  sp: "599px",
  tablet: "867px",
  pc: "1000px",
};
